import { ArrowBack, Close } from "@mui/icons-material";
import React, { useState } from "react";

const NavigationHintBox = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-b border-amber-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-2.5">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2 text-sm">
              <div className="w-5 h-5 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-amber-700 text-xs font-medium">!</span>
              </div>
              <span className="text-amber-800 font-medium">Navigation:</span>
              <span className="text-amber-700">
                Please use the back button to return to the previous page. Do
                not use the{" "}
                <span className="inline-flex items-center space-x-1 bg-white px-2 py-0.5 rounded-md border border-amber-200 text-xs font-medium text-amber-800 shadow-sm">
                  <ArrowBack style={{ fontSize: 12 }} />
                </span>{" "}
                button in the browser.
              </span>
            </div>
          </div>

          <button
            onClick={() => setIsVisible(false)}
            className="flex-shrink-0 p-1 rounded-md text-amber-500 hover:text-amber-700 hover:bg-amber-100 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-1"
            aria-label="Dismiss navigation notice"
            title="Dismiss this notice"
          >
            <Close style={{ fontSize: 16 }} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavigationHintBox;
